import { apiMipe } from '@/core/api/';
import qs from 'querystring';

export const getSysparameterByNames = async (params) => {
  return await apiMipe.get(`/api/sysparameter/byparameternames`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });
};
